'use strict';

var ProfileChartToolbarDirective = function ProfileChartToolbarDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/profile-chart-toolbar.html'),
    controller: 'ProfileChartToolbarController',
    scope: {
      contextData: '='
    }
  };
};
ProfileChartToolbarDirective.$inject = [];
module.exports = ProfileChartToolbarDirective;